import { Component, Input, OnInit } from '@angular/core';
import { PracticesService } from '@services/practices.service';
import { LoggerService } from '@services/logger.service';
import { faInbox, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-ms-azp-tab-component',
  templateUrl: './ms-azp-tab-component.component.html',
  styleUrls: ['./ms-azp-tab-component.component.scss'],
})
export class MsAzpTabComponentComponent implements OnInit {
  @Input() practiceId!: number;
  panelOpenState: boolean = false;
  bigBuyersData: any[] = [];
  promotionalActionsData: any[] = [];
  loadingBigBuyers: boolean = false;
  loadingPromotionalActions: boolean = false;
  readonly faInbox: IconDefinition = faInbox;

  columnsBigBuyers = [
    { field: 'codice', header: 'Codice', type: 'string' },
    { field: 'percentuale', header: 'Percentuale', type: 'percentage' },
    { field: 'importo', header: 'Importo', type: 'currency' },
    { field: 'dataLiquidazioneContributo', header: 'Data Liquidazione Contributo', type: 'date' },
    { field: 'numeroDistinta', header: 'Numero Distinta', type: 'string' },
    { field: 'numeroCommissione', header: 'Numero Commissione', type: 'string' },
  ];

  columnsPromotionalActions = [
    { field: 'codice', header: 'Codice', type: 'string' },
    { field: 'percentuale', header: 'Percentuale', type: 'percentage' },
    { field: 'importo', header: 'Importo', type: 'currency' },
  ];

  constructor(private practiceService: PracticesService) {}

  ngOnInit() {
    if (this.practiceId) {
      this.loadBigBuyers();
      this.loadPromotionalActions();
    }
  }

  loadBigBuyers() {
    this.loadingBigBuyers = true;
    this.practiceService.getBigBuyersByPracticeId(this.practiceId).subscribe({
      next: (data) => {
        LoggerService.log(data, 'getBigBuyersByPracticeId');
        this.bigBuyersData = Array.isArray(data) ? data : [];
        this.loadingBigBuyers = false;
      },
      error: (error) => {
        LoggerService.error('getBigBuyersByPracticeId failed!');
        LoggerService.error(error);
        this.bigBuyersData = [];
        this.loadingBigBuyers = false;
      },
    });
  }

  loadPromotionalActions() {
    this.loadingPromotionalActions = true;
    this.practiceService.getPromotionalActionsByPracticeId(this.practiceId).subscribe({
      next: (data) => {
        LoggerService.log(data, 'getPromotionalActionsByPracticeId');
        this.promotionalActionsData = Array.isArray(data) ? data : [];
        this.loadingPromotionalActions = false;
      },
      error: (error) => {
        LoggerService.error('getPromotionalActionsByPracticeId failed!');
        LoggerService.error(error);
        this.promotionalActionsData = [];
        this.loadingPromotionalActions = false;
      },
    });
  }
}
